import { render, staticRenderFns } from "./trailer.vue?vue&type=template&id=db666b26&scoped=true&"
import script from "./trailer.vue?vue&type=script&lang=js&"
export * from "./trailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db666b26",
  null
  
)

export default component.exports